import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { servicesGeneral1 } from "../../../assets/images";

const tabs = [
  {
    key: "first",
    title: "Caspian Rock Solutions LLC",
    description: "Caspian Rock Solutions was established in 2025.",
    image: servicesGeneral1,
    links: [
      { label: "INDUSTRIAL INSULATION SERVICES", url: "industrial" },
      { label: "CONSULTANCY SERVICES", url: "consultancy" },
      { label: "TRAINING & TECHNICAL SUPPORT", url: "training" },
      { label: "MAINTENANCE & REPAIR", url: "maintenance" },
    ],
  },
  // {
  //   key: 'second',
  //   title: 'Caspian Rock Solutions Kazakhstan LLP',
  //   description: 'Caspian Rock Solutions Kazakhstan was established in 2011.',
  //   image: servicesGeneral2,
  //   links: [
  //     { label: 'DRILL BITS (PDC/RC)', url: 'drillbits' },
  //     { label: 'CORING & CORE ANALYSIS', url: 'coring' },
  //     { label: 'GEOLOGICAL INTELLIGENCE FOR DRILLING: POWERED BY ADVANCED SOFTWARE', url: 'geological' },
  //   ],
  // },
  // {
  //   key: 'third',
  //   title: 'Caspian Rock Solutions F.Z.C',
  //   description: 'Caspian Rock Solutions F.Z.C was established in 2009.',
  //   image: servicesGeneral3,
  //   links: [
  //     { label: 'DRILL BITS (PDC/RC)', url: 'drillbits' },
  //     { label: 'CORING & CORE ANALYSIS', url: 'coring' },
  //     { label: 'GEOLOGICAL INTELLIGENCE FOR DRILLING: POWERED BY ADVANCED SOFTWARE', url: 'geological' },
  //   ],
  // }
];

const IndustrialServices = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const [activeTab, setActiveTab] = useState("first");

  const activeContent = tabs.find((tab) => tab.key === activeTab);

  return (
    <div className="bg-[#EDEDED] py-[40px] md:py-[80px]">
      <div className="max-w-containerSm md:max-w-container mx-auto">
        {/* TABS */}
        <div className="flex flex-col md:flex-row justify-between gap-4">
          {/* SOLDA TABS */}
          <div className="w-full md:w-[268px] space-y-2 flex-col gap-2 md:mt-[100px]">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                className={`text-left py-2 px-4 min-h-[64px] w-full border rounded font-medium ${
                  activeTab === tab.key
                    ? "border-[#B31F11] border-l-[10px] border-t border-r border-b bg-white text-[#222]"
                    : "border border-gray-300 bg-white text-[#222]"
                }`}
              >
                {tab.title}
              </button>
            ))}
          </div>

          {/* SAĞDA İÇERİK */}
          <div className="w-full md:w-[883px] mt-10 md:mt-0">
            <p className="text-[22px] md:text-[44px] font-bold text-[#141615] font-firstFont">
              {activeContent.title}
            </p>

            <p className="text-[#41444B] mt-10 text-[14px] md:text-[18px] leading-relaxed">
              {activeContent.description}
            </p>

            {/* Links */}
            <div className="mt-6">
              <p className="text-[16px] font-semibold text-[#141615] mb-2">
                {t("Services")}
              </p>
              <ul className="list-disc list-inside space-y-2">
                {activeContent.links.map((link, index) => (
                  <li key={index}>
                    <a
                      href={`/${currentLanguage}/industrial/services/${link.url}`}
                      rel="noopener noreferrer"
                      className="text-[#B31F11] hover:underline"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <img
              src={activeContent.image}
              alt={activeContent.title}
              className="w-full h-auto rounded mt-8"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default IndustrialServices;
